<script lang="ts" module>
	type TData = unknown;
</script>

<script lang="ts" generics="TData">
	import X from '@lucide/svelte/icons/x';
	import type { Table } from '@tanstack/table-core';
	import Button from '$lib/components/ui/button/button.svelte';
	import DataTableFacetedFilter from '$lib/components/general/data-table/data-table-faceted-filter.svelte';

	let {
		table,
		locations,
		years
	}: {
		table: Table<TData>;
		locations: (string | undefined)[];
		years: (number | undefined)[];
	} = $props();

	const isFiltered = $derived(table.getState().columnFilters.length > 0);
	const locationCol = $derived(table.getColumn('locationGroup'));
	const yearCol = $derived(table.getColumn('year'));
</script>

<div class="flex items-center justify-between overflow-y-auto">
	<div class="flex flex-1 items-center space-x-2">
		{#if locationCol}
			<DataTableFacetedFilter
				column={locationCol}
				title="Standort"
				options={locations
					.filter((v): v is string => v !== undefined)
					.map((v) => ({
						label: v,
						value: v
					}))}
			/>
		{/if}

		{#if yearCol}
			<DataTableFacetedFilter
				column={yearCol}
				title="Jahr"
				options={years
					.filter((v): v is number => v !== undefined)
					.map((v) => ({
						label: v.toString(),
						value: v.toString()
					}))}
			/>
		{/if}

		{#if isFiltered}
			<Button variant="ghost" onclick={() => table.resetColumnFilters()} class="h-8 px-2 lg:px-3">
				Reset
				<X />
			</Button>
		{/if}
	</div>
</div>
